import create, { SetState } from 'zustand';

export interface NativeSearchQueryStore {
  email: string;
  setEmail: (email: string) => void;
}

export const useNativeSearchQueryStore = create<NativeSearchQueryStore>(
  (set: SetState<NativeSearchQueryStore>) => ({
    email: '',
    setEmail: (email: string) => set({ email: email }),
  })
);
